import React from 'react'
import {Loading} from '@therms/atalaya'
import {useLocationContext, useRPC} from '@therms/react-modules'
import {RPCDocs, RPCs} from '@therms/rpc-gateway'
import {LocationTaskCompletionListCard} from '@src/modules/Locations/components/LocationTaskCompletionListCard.tsx'

export function LocationTaskCompletionList() {
  const {locationId} = useLocationContext(true)
  const {data, isCalling} = useRPC<
    RPCDocs.Locations.GetLocationTaskCompletions.v1.Args,
    RPCDocs.Locations.GetLocationTaskCompletions.v1.Data
  >(RPCs.Locations.GetLocationTaskCompletions.v1, {
    locationAndGroupIds: [locationId],
  })

  return (
    <div className="space-y-xs">
      {isCalling && !data?.locationTaskCompletions && <Loading overlay />}

      {data?.locationTaskCompletions?.map((completion) => (
        <div className="bg-surface rounded" key={completion.id}>
          <LocationTaskCompletionListCard locationTaskCompletion={completion} />
        </div>
      ))}
    </div>
  )
}
